import styled from 'styled-components'
import { InlineEditorForm as InlineEditorFormBase } from '../InlineEditorForm'

export const InlineEditorForm = styled(InlineEditorFormBase)<{
  depth: number
}>`
  padding-left: ${({ depth }) => 12 * (depth - 1)}px;
`
